export default {
    setFeatureConfiguration(state, payload) {
        state.features = payload
    }
}